import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { installTableCards } from "./utils/tableCards";
import { queryClient } from "./queryClient";
import "./index.css";            // ← MUITO IMPORTANTE
import "./styles/theme.css";
import "./styles/ui.css";
import "./styles/public.css";
import { applyStoredTheme } from "./hooks/useTheme";

// Tema claro/escuro escolhido pelo utilizador, aplicado antes do primeiro render.
applyStoredTheme();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Tabelas com className="table-cards" viram cartões no telemóvel (ver utils/tableCards.js).
installTableCards();
